module.exports = __webpack_public_path__ + "img/logo.ab835476.png";